import React from 'react';

const LoadingSpinner = () => {
  return (
    <div 
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: '#050507' }}
      data-testid="loading-spinner"
    >
      <div className="text-center">
        <div className="relative w-16 h-16 mx-auto mb-4">
          <div 
            className="absolute inset-0 rounded-full border-4 border-t-transparent animate-spin"
            style={{ borderColor: 'rgba(255,255,255,0.06)', borderTopColor: '#f0f0f0' }}
          />
        </div>
        <p className="font-inter text-sm" style={{ color: '#888' }}>
          Loading...
        </p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
